import { Inject, Injectable } from "@angular/core";
import { DwOrmDataService, DwOrmDataServiceToken } from "@devwareapps/devware-cap";


import * as moment_ from 'moment';
import { Observable } from "rxjs";
import { TimerEntity, TimersMetaData, TimersMetaDataService, TimerStatusAllItems, TimerTypeAllItems } from "../meta-data/timers-meta-data.service";
import { TimerCardClass } from "../models/timer-card-class.model";
import { TimerConfig } from "../models/timer-config.model";
const moment = moment_;

@Injectable({ providedIn: 'root' })
export class TimerUtilService {
    readonly momentDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
    readonly momentDateTimeFormat2 = 'MM/DD/YYYY hh:mm:ss A';

    readonly minutesConst = 60;
    readonly hoursConst = 60 * 60;
    readonly daysConst = this.hoursConst * 24;

    constructor(@Inject(DwOrmDataServiceToken) protected ormDataService: DwOrmDataService) {
        
    }

   
    
    addDateTimeOffset(minuteOffset: number): string {
        let dateTimeStr = moment().utc().add(minuteOffset, 'minute').format(this.momentDateTimeFormat2)

        return dateTimeStr;
    }


    getLastModifiedTimer(): Observable<TimerEntity> {
        const query = TimersMetaData.Timer.CreateQuery();
        
        query.OrderBy(TimersMetaData.Timer.ModifiedByDateTime, false);

        return this.ormDataService.executeQuerySingle(query);
    }

    getCurrentCountdownValue(timer: TimerEntity, referenceDateTime: string, countUp: boolean, timeLeftAdjustment: number = 0): number {
        if (timer.TimerStatusId == TimerStatusAllItems.Complete) {
            return null;
        }

        // Determine which date field to use
        //const isJobTimer = timer.TimerTypeId == TimerTypeAllItems.JobTimer;

        //const referenceDateTime = isJobTimer ? timer.DueDateTime : timer.StartDateTime;

        if (!referenceDateTime) {
            return null;
        }

        const dueDateTime = this.convertToMoment(referenceDateTime, true);
        const currentDateTime = moment();
    
        let timeLeftSeconds = dueDateTime.diff(currentDateTime, 'seconds');

        // Add one second so it shows the original time on start (otherwise it calcs to 14:59 instead of 15:00) - However, for Tech Timers, it started at -0:01 instead of 0:00
        // if (timer.TimerTypeId == TimerTypeAllItems.JobTimer) {
        //     timeLeftSeconds += 1;
        // }

        if (timeLeftAdjustment) {
            timeLeftSeconds += timeLeftAdjustment;
        }

        // Only job timers count down (NOTE: could load the timer type record and use its value, but would require an obversable so making it easy for now)
        if (countUp) {
            timeLeftSeconds = -timeLeftSeconds;
        }
    
        return Math.ceil(timeLeftSeconds);
    }

    saveTimer(timer: TimerEntity): Observable<TimerEntity> {
        return this.ormDataService.saveEntity(timer);
    }

    formatDuration(timeInSeconds: number) {
        const isNegative = (timeInSeconds<0);
        if (isNegative) {
            timeInSeconds = -timeInSeconds;
        }

        let totalSeconds = timeInSeconds;

 
        const seconds = (totalSeconds % 60);

        let totalMinutes = (timeInSeconds - seconds) / 60;

        const minutes = totalMinutes % this.minutesConst;

        let totalHours = (totalMinutes - minutes) / 60;

        const hours = totalHours % 24;

        let days = (totalHours - hours) / 24;

        let prefix = '';

        if (days == 1) {
            prefix = '1 day ';
        }
        if (days > 1) {
            prefix = `${days.toFixed(0)} days `
        }

        if (isNegative) {
            prefix = '-' + prefix;
        }

        if (hours>0) {
            return `${prefix}${this.pad(hours, 2)}:${this.pad(minutes, 2)}:${this.pad(seconds, 2)}`;
        }

        return `${prefix}${this.pad(minutes, 2)}:${this.pad(seconds, 2)}`;
    }

    private pad(num: number, size = 0, decimals = 0) {
        var numString = num.toFixed(0).toString();
        while (numString.length < size) numString = "0" + numString;
        return numString;
    }

    convertToMoment(value: string, timeIsUtc: boolean): moment_.Moment {
        let format = this.momentDateTimeFormat2;

        const hasDash = (value.substring(4, 5) === '-')

        if (hasDash) {
            format = this.momentDateTimeFormat;
        }

        if (timeIsUtc) {
            return moment.utc(value, format);
        }

        return moment(value, format);
    }

    getCurrentTimerClass(timerEntity: TimerEntity, timerConfig: TimerConfig, timeInSeconds?: number) {
        let classKey = '';

        if (timerEntity.TimerStatusId == TimerStatusAllItems.Active) {
            const timeInMinutes = timeInSeconds / 60;

            const timerInteval = timerConfig?.timerIntervals?.find(ti => 
                (!ti.maxTimerValueMinutes || ti.maxTimerValueMinutes >= timeInMinutes) &&
                (!ti.minTimerValueMinutes || ti.minTimerValueMinutes <= timeInMinutes)
            );

            if (timerInteval) {
                classKey = timerInteval.cardClassKey;
            }
        } else {
            // Completed always show as gray
            classKey="gray";
        }

        if (classKey) {
            const timerClasses = this.getTimerCardClasses()

            return timerClasses.find(tc => tc.key == classKey)?.className;
        }
    }

    getTimerCardClasses(): TimerCardClass[] {
        return [
            {
                key: 'green',
                display:'Green',
                className: 'wa-green-top'
            },
            {
                key: 'yellow',
                display:'Yellow',
                className: 'wa-yellow-top'
            },
            {
                key: 'orange',
                display:'Orange',
                className: 'wa-orange-top'
            },
            {
                key: 'red',
                display:'Red',
                className: 'wa-red-top'
            },
            {
                key: 'blue',
                display:'Blue',
                className: 'wa-blue-top'
            },
            {
                key: 'gray',
                display:'Gray',
                className: 'wa-gray-top'
            },
        ]
    }

}